import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PurchaseOrderHeaderCreate,
    PurchaseOrderHeaderDto,
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderSearchParams,
} from '../../entities/purchase-order-header.dto';
import { Injectable } from '@angular/core';
import { PlatformOrdersMapper } from '../platform-orders.mapper';
import { PurchaseOrderHeaderMetadataMap } from './purchase-order-header.mapping-profile';

@Injectable()
export class PurchaseOrderHeaderMapper extends AbstractEntityMapper<
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderCreate,
    PurchaseOrderHeaderDto,
    PurchaseOrderHeaderSearchParams
> {
    constructor() {
        super(
            PurchaseOrderHeaderDto,
            PlatformOrdersMapper,
            PurchaseOrderHeaderMetadataMap.symbols
        );
    }
}
